export default __webpack_public_path__ + "static/nickelHero-46409996929481c6929d89b5e529b46c.jpg";